import { useLayoutEffect } from "react";
import GalleryContent from "../../Pages/Gallery/GalleryContent/GalleryContent.js";
import BrandedCoverUploader from "../../Reusable/BrandedCoverUploader/BrandedCoverUploader.js";
import NotSubscriberModal from "../../Reusable/NotSubscriberModal/NotSubscriberModal.js";
import useMailSender from "../../../hooks/useMailSender.js";
import ForBusinessOnlyModal from "../../Reusable/ForBusinessOnlyModal/ForBusinessOnlyModal.js";
import NotEnoughSpaceModal from "../../Reusable/SaveMail/NotEnoughSpaceModal.js";
import FailedAPICommunication from "../../Reusable/FailedAPICommunication/FailedAPICommunication.js";
import RecaptchaV3 from "components/Reusable/RecaptchaV3/RecaptchaV3.jsx";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useParams } from "react-router-dom";
import { useRecaptcha } from "contexts/recaptchaContext/recaptchaContext.js";

import "./Gallery.scss";

const Gallery = () => {
  const params = useParams();
  const { setModal } = useModal();
  const { getShowRecaptcha } = useRecaptcha();
  const { isMailSenderAndBusinessSubscriber, isMailSender } = useMailSender();
  const {
    getSender,
    setMailStatus,
    setAlertToUser,
    setIsDisplayAllowed,
    setSecurity,
    setDeleteHashId,
  } = useMail();
  const { isLoggedIn } = useUser();

  useLayoutEffect(() => {
    //check if existing
    //QA checking sector
    if (params.anotherParam === "general-subscription") {
      setModal({
        modal: NotSubscriberModal,
      });
    } else if (params.anotherParam === "business-subscription") {
      setModal({
        modal: ForBusinessOnlyModal,
      });
    } else if (params.anotherParam === "communication-failed") {
      setModal({
        modal: FailedAPICommunication,
        modalSize: "full-modal",
      });
    } else if (params.anotherParam === "mail-removed") {
      setMailStatus("removed");
    } else if (params.anotherParam === "upload-progress") {
      setMailStatus("uploading");
    } else if (params.anotherParam === "upload-error") {
      setAlertToUser({
        text: "mail-status-upload-error-textbox-title",
        icon: "warning",
        color: "red",
        allowClosing: false,
      });
    } else if (params.anotherParam === "files-error") {
      setMailStatus("error");
    } else if (params.anotherParam === "access-denied") {
      setMailStatus("violation");
    } else if (params.anotherParam === "suspicions-malware") {
      setAlertToUser({
        text: "mail-status-suspicions-malware",
        icon: "warning",
        color: "red",
        allowClosing: false,
      });
    } else if (params.anotherParam === "password-required") {
      setIsDisplayAllowed(true);
      setSecurity({ isPasswordProtected: true, isSharingAvailable: false });
    } else if (params.anotherParam === "not-enough-space") {
      setModal({
        modal: NotEnoughSpaceModal,
      });
    }

    //END OF QA SECTOR

    //check if param is select-cover and user logged in
    else if (params.anotherParam === "select-cover" && isLoggedIn()) {
      //if user is not an owner of email
      if (!isMailSender()) {
        params.fileId = params.anotherParam;
        return;
      }
      // if user is the owner of the page and is a subscriber
      if (isMailSenderAndBusinessSubscriber()) {
        setModal({
          modal: BrandedCoverUploader,
        });
        // if user is not a business subscriber
      } else if (isMailSender()) {
        setModal({
          modal: ForBusinessOnlyModal,
        });
      } else {
        setModal({
          modal: NotSubscriberModal,
        });
      }
    } else if (params.anotherParam === "upload-complete") {
      return;
    } else if (params.anotherParam === "delete") {
      params.deleteMailParams && setDeleteHashId(params.deleteMailParams);
      return;
    } else {
      //when specific picture is chosen
      if (params.anotherParam) params.fileId = params.anotherParam;
    }
  }, [getSender(), isLoggedIn()]);

  return (
    <>
      <GalleryContent />
      {getShowRecaptcha().gallery && (
        <RecaptchaV3 callback={getShowRecaptcha().gallery} />
      )}
    </>
  );
};

export default Gallery;
